module.exports = __webpack_public_path__ + "static/media/pdf-disabled.61bc8d37.svg";